export default __webpack_public_path__ + "static/media/Roboto-Regular-with-special.9bb8205f.ttf";